var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
       '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>ATG0</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>ATG1</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>ATG2</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>ATG3</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>ATG4</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>ATG5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>ATG6</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'" >'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                         '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="ATG 0" data-betCode="420" class="bet-choose" data-odd="'+quotes.Away0+'">'+globalFunctions.checkQuotes(quotes.Away0)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="ATG 1" data-betCode="421" class="bet-choose" data-odd="'+quotes.Away1+'">'+globalFunctions.checkQuotes(quotes.Away1)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="ATG 2" data-betCode="422" class="bet-choose" data-odd="'+quotes.Away2+'">'+globalFunctions.checkQuotes(quotes.Away2)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="ATG 3" data-betCode="423" class="bet-choose" data-odd="'+quotes.Away3+'">'+globalFunctions.checkQuotes(quotes.Away3)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="ATG 4" data-betCode="424" class="bet-choose" data-odd="'+quotes.Away4+'">'+globalFunctions.checkQuotes(quotes.Away4)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="ATG 5" data-betCode="425" class="bet-choose" data-odd="'+quotes.Away5+'">'+globalFunctions.checkQuotes(quotes.Away5)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="ATG 6" data-betCode="426" class="bet-choose">'+globalFunctions.checkQuotes(quotes.Away6)+'</li>'+
                            '</ul>'+
                        '</div> '+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/away_goals.js
// module id = 2013
// module chunks = 4